export enum ChatsSenderEnum {
    USER = "user",
    AGENT = "agent",
}